export default __webpack_public_path__ + "static/media/MLBChaseBGTeamManager.cdcd7fb6.png";